module.exports = __webpack_public_path__ + "static/media/bootstrap_stack.46c9c49f.png";